<button id="{{id}}" class="btn-primary flex relative items-center justify-center cursor-pointer" [ngClass]="{'gray': color === 'gray', 'orange': color === 'orange'}" [disabled]="disabled" (click)="btnFunction.emit()">
    <div class="inner-btn w-full"></div>
    <div class="btn-text absolute">{{btnText}}</div>
</button>